const Mutations = Object.freeze({
	SET_STATIC_FIELDS: 'activityBuilder/activityStaticFields/SET_STATIC_FIELDS',
	SET_STATIC_FIELDS_ADD:
		'activityBuilder/activityStaticFields/SET_STATIC_FIELDS_ADD',
	SET_SELECTED_STATIC_FIELD:
		'activityBuilder/activityStaticFields/SET_SELECTED_STATIC_FIELD',
	SET_STATIC_FIELD_UPDATE:
		'activityBuilder/activityStaticFields/SET_STATIC_FIELD_UPDATE',
	SET_STATIC_FIELD_DELETE:
		'activityBuilder/activityStaticFields/SET_STATIC_FIELD_DELETE',
	SET_LOADING: 'activityBuilder/activityStaticFields/SET_LOADING',
});

export const Actions = Object.freeze({
	CLEAR: 'activityBuilder/activityStaticFields/CLEAR',
	LOAD_STATIC_FIELDS:
		'activityBuilder/activityStaticFields/LOAD_STATIC_FIELDS',
	SET_SELECTED_STATIC_FIELD:
		'activityBuilder/activityStaticFields/SET_SELECTED_STATIC_FIELD',
	INSERT_STATIC_FIELD:
		'activityBuilder/activityStaticFields/INSERT_STATIC_FIELD',
	UPDATE_STATIC_FIELD:
		'activityBuilder/activityStaticFields/UPDATE_STATIC_FIELD',
	DELETE_STATIC_FIELD:
		'activityBuilder/activityStaticFields/DELETE_STATIC_FIELD',
});

export const Getters = Object.freeze({
	STATIC_FIELDS: 'activityBuilder/activityStaticFields/STATIC_FIELDS',
	SELECTED_STATIC_FIELD:
		'activityBuilder/activityStaticFields/SELECTED_STATIC_FIELD',
	LOADING: 'activityBuilder/activityStaticFields/LOADING',
});
import { GeneralActions } from '../../../../actions';
import dataService from '../../../../../services/data/activityDataService';
export default {
	state: {
		staticFields: [],
		selectedStaticField: null,
		loading: false,
	},
	mutations: {
		[Mutations.SET_STATIC_FIELDS](state, items) {
			state.staticFields = items;
		},
		[Mutations.SET_SELECTED_STATIC_FIELD](state, item) {
			state.selectedStaticField = item;
		},
		[Mutations.SET_STATIC_FIELDS_ADD](state, item) {
			state.staticFields.push(item);
		},
		[Mutations.SET_STATIC_FIELD_DELETE](state, id) {
			let deleteIndex = state.staticFields.findIndex((x) => x.Id === id);
			state.staticFields.splice(deleteIndex, 1);
		},
		[Mutations.SET_STATIC_FIELD_UPDATE](state, item) {
			let index = state.staticFields.findIndex((x) => x.Id === item.Id);
			state.staticFields.splice(index, 1, item);
		},
		[Mutations.SET_LOADING](state, item) {
			state.loading = item;
		},
	},
	actions: {
		[Actions.CLEAR]({ commit }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_STATIC_FIELDS, []);
				commit(Mutations.SET_SELECTED_STATIC_FIELD, null);
				resolve();
			});
		},
		[Actions.SET_SELECTED_STATIC_FIELD]({ commit }, item) {
			commit(Mutations.SET_SELECTED_STATIC_FIELD, item);
		},

		[Actions.LOAD_STATIC_FIELDS]({ commit, dispatch }, id) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				commit(Mutations.SET_LOADING, true);
				dataService
					.getStaticFieldsByActivityId(id)
					.then((resp) => {
						commit(Mutations.SET_STATIC_FIELDS, resp.data);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						commit(Mutations.SET_LOADING, false);
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.INSERT_STATIC_FIELD]({ commit, dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.insertStaticField(item)
					.then((resp) => {
						commit(Mutations.SET_STATIC_FIELDS_ADD, resp.data);
						dispatch(GeneralActions.LOADING, false);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve(false);
					});
			});
		},
		[Actions.UPDATE_STATIC_FIELD]({ commit, dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.updateStaticField(item)
					.then(() => {
						commit(Mutations.SET_STATIC_FIELD_UPDATE, item);
						dispatch(GeneralActions.LOADING, false);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
						resolve(false);
					});
			});
		},
		[Actions.DELETE_STATIC_FIELD]({ commit, dispatch }, id) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.deleteStaticField(id)
					.then(() => {
						commit(Mutations.SET_STATIC_FIELD_DELETE, id);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(null);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
	},
	getters: {
		[Getters.STATIC_FIELDS]: (state) => {
			return JSON.parse(JSON.stringify(state.staticFields));
		},
		[Getters.SELECTED_STATIC_FIELD]: (state) => {
			return JSON.parse(JSON.stringify(state.selectedStaticField));
		},
		[Getters.LOADING]: (state) => {
			return state.loading;
		},
	},
};
